<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/performancePersonList' }">绩效人员</el-breadcrumb-item>
                <el-breadcrumb-item>绩效人员{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :class="in_array(item.prop, ['business_unit_rid', 'master_code', 'person_code']) ? 'is-required' : ''"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    :class="in_array(item.prop, ['name', 'period_code']) ? 'is-required' : ''"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="item['prop'] == 'aaaaa'"
                                        clearable
                                    ></el-input>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNaturalNumber, checkNumber } from '@/js/common.js';

export default {
    name: 'performancePersonEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.config_rid = this.$route.query.config_rid || '';
            this.initFormData();
        }
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                config_rid: {
                    request_uri: 'dropdownPerformancePersonConfig',
                    title: '绩效人员配置',
                    ref: 'config_rid_ref',
                    type: 'dropdown',
                    select_value: 'code',
                    tips: '[类型.限额类型.基数类型]'
                },
                person_code: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_code_ref',
                    type: 'dropdown',
                    select_value: 'code'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                },
                quota_confirmed: {
                    tips: '限额类型为填充时必填'
                },
                base_confirmed: {
                    tips: '基数类型为填充时必填'
                },
                quota_adjustment: {
                    tips: '重算后汇总到绩效单元'
                },
                percent: {
                    tips: '限额类型为比例时必填，单位：%，取值范围：[0,100]'
                },
                factor: {
                    tips: '取值范围：[0,1]，默认：1'
                }
            };
        },
        initFormRule() {
            this.rules = {
                config_rid: [{ required: true, message: '请选择绩效人员配置', trigger: 'blur' }],
                start_date: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请输入结束日期', trigger: 'blur' }],
                person_code: [{ required: true, message: '请选择人员', trigger: 'blur' }],
                quota_confirmed: { required: false, validator: checkNumber, trigger: 'blur' },
                quota_released_confirmed: { required: false, validator: checkNumber, trigger: 'blur' },
                base_confirmed: { required: false, validator: checkNumber, trigger: 'blur' },
                quota_adjustment: { required: false, validator: checkNumber, trigger: 'blur' },
                percent: { required: false, validator: checkNumber, trigger: 'blur' },
                factor: { required: true, validator: checkNumber, trigger: 'blur' },
                remark: [{ required: false, message: '请输入备注', trigger: 'blur' }]
            };
        },

        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                id: this.data.id || '0',
                config_rid: this.data.config_rid || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                person_code: this.data.person_code || '',
                quota_confirmed: this.data.quota_confirmed !== null ? this.data.quota_confirmed : '',
                quota_released_confirmed: this.data.quota_released_confirmed !== null ? this.data.quota_released_confirmed : '',
                base_confirmed: this.data.base_confirmed !== null ? this.data.base_confirmed : '',
                quota_adjustment: this.data.quota_adjustment !== null ? this.data.quota_adjustment : '',
                percent: this.data.percent !== null ? this.data.percent : '',
                factor: this.data.factor !== null ? this.data.factor : '',
                remark: this.data.remark || ''
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).performance_person;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'config_rid',
                        'start_date',
                        'end_date',
                        'person_code',
                        'quota_confirmed',
                        'quota_released_confirmed',
                        'base_confirmed',
                        'quota_adjustment',
                        'percent',
                        'factor',
                        'remark'
                    ]
                },
                {}
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'performancePersonList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .performancePersonDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'performancePersonUpdate';
            } else {
                uri = 'performancePersonInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>